//region :: Imports ::
import {Component} from 'react';
import produce from 'immer';

//endregion

/** */
class MComponent<TProps extends object = {}, TState extends object = {}> extends Component<TProps, TState> {

    /** */
    protected safeSetState(recipe: (draft: TState) => void): void {

        this.setState((state: TState) => produce(state, (draft: TState) => {
            recipe(draft);
        }));

    }

}

export default MComponent;
